// Valeurs de data-template-id des widgets Trustpilot
// À compléter si besoin
export const TP_WIDGETS = {
  productReviews: '544a426205dc0a09088833c6',
  productReviewsMultiSource: '57177697fdb1180308e3815f',
  mini: '53aa8807dec7e10d38f59f32', // Trustscore
  companySlider: '54ad5defc6454f065c28af8b', // Avis société - Vue carousel
};
